import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import React from 'react';

const ActiveInput = ({ value, onChange }) => (
  <Tooltip title={value === false ? 'Activate' : 'Deactivate'}>
    <Button
      type={value === false ? 'primary' : 'default'}
      danger={value === false}
      icon={value === false ? <EyeInvisibleOutlined /> : <EyeOutlined />}
      onClick={() => onChange(value === false)}
    />
  </Tooltip>
);

export default ActiveInput;
